// extracted by mini-css-extract-plugin
module.exports = {"closeIconContainer":"ThanksModal_closeIconContainer__2ekcm","closeIcon":"ThanksModal_closeIcon__3i-Iu","customThanks":"ThanksModal_customThanks__2mIm2"};